module.exports = __webpack_public_path__ + "static/assets/40197a2951083fd76c660d1d108aaddd.svg";